import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getNewsList } from "../../../../services/apiNews";
import NewsDataTable from "./NewsDataTable";
import NewsSearchForm from "./NewsSearchForm";

const NewsList = () => {
  // 画面表示モード(初期表示)
  const { type } = useParams();
  // 画面表示モード
  const [displayType, setDisplayType] = useState(Number(type));
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // お知らせ一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // 全体へのお知らせ
  const EntireNews = 1;
  // あなたへのお知らせ
  const YourNews = 2;
  const navigate = useNavigate();

  // 画面表示モード変更
  const changeDisplayType = (displayType) => {
    setDisplayType(displayType);
    // タブ切り替えたら1ページ目に戻るようにする
    setCurrentPage(1);
  };

  // 検索フォーム
  const returnSearchForm = () => {
    return (
      <NewsSearchForm
        setSearchCondition={setSearchCondition}
        setTableData={setTableData}
      />
    );
  };

  // タブ
  const returnTab = (displayType) => {
    return (
      <div className="p-course-tab" role="tablist">
        <button
          type="button"
          className={`p-course-tab__link ${
            displayType === EntireNews ? "active" : ""
          }`}
          onClick={() => changeDisplayType(EntireNews)}
          aria-selected={displayType === EntireNews ? "true" : "false"}
          role="tab"
        >
          全体へのお知らせ
        </button>
        <button
          type="button"
          className={`p-course-tab__link ${
            displayType === YourNews ? "active" : ""
          }`}
          onClick={() => changeDisplayType(YourNews)}
          aria-selected={displayType === YourNews ? "true" : "false"}
          role="tab"
        >
          あなたへのお知らせ
        </button>
      </div>
    );
  };

  // お知らせ一覧
  const returnDataTable = (displayType) => {
    let allData = tableData;
    var dispData = [];
    if (allData) {
      if (displayType === EntireNews) {
        // 全体へのお知らせデータ
        dispData = allData.filter((val) => {
          return val.published_to === 1;
        });
      } else if (displayType === YourNews) {
        // あなたへのお知らせデータ
        dispData = allData.filter((val) => {
          return val.published_to !== 1;
        });
      }
    }
    return (
      <NewsDataTable
        tableData={dispData}
        displayType={displayType}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  // 検索条件更新時
  useEffect(() => {
    (async function () {
      // 画面表示モードが正しくなかったら404エラー
      if (displayType !== EntireNews && displayType !== YourNews) {
        navigate("/mypage/notfound");
      }
      const data = await getNewsList(searchCondition);
      if (data == undefined || !data) return;
      setCurrentPage(1);
      setTableData(data);
    })();
  }, [searchCondition]);

  return (
    <div className="l-page-right">
      <div className="l-page-con">
        <h1 className="p-heading01">お知らせ</h1>
        {returnSearchForm()}
        {returnTab(displayType)}
        <div className="p-course__con" role="tabpanel">
          {returnDataTable(displayType)}
        </div>
      </div>
    </div>
  );
};

export default NewsList;
